import { Trans, useTranslation } from '@ecomm/i18n'
import React from 'react'

export const ProPlusBusinessDescription = () => {
  const { t } = useTranslation('maps')
  return <Trans t={t} i18nKey="plan-description.pro-plus-business" />
}
